"use client";

import Script from "next/script";

export default function WLAIChat({ widgetId }) {

  if (!widgetId) return

  return (
    <Script
        src={`${process.env.NEXT_PUBLIC_CHATBOT_BASE_URL}/widget/chat-widget.js`}
        data-api-url={`${process.env.NEXT_PUBLIC_CHATBOT_BASE_URL}/api/chat`}
        data-widget-id={widgetId}
        strategy="lazyOnload"
        data-test-mode="true"
    />
  );
}
